<template>
  <div class="profit-page">
    <h2 class="font-500 auth-page-title">{{ $t('profit.title') }}</h2>
    <div class="auth-page-section">
      <div class="table-container">
        <sorted-table class="ic-table" :values="values">
          <thead>
          <tr>
            <th><sort-link name="symbol">{{ $t('profit.header.symbol') }}</sort-link></th>
            <th><sort-link name="created_at">{{ $t('profit.header.date') }}</sort-link></th>
            <th class="right"><sort-link name="avgPayPrice">{{ $t('profit.header.buy_price') }}</sort-link></th>
            <th class="right"><sort-link name="soldPrice">{{ $t('profit.header.sell_price') }}</sort-link></th>
            <th class="right"><sort-link name="amount">{{ $t('profit.header.quantity') }}</sort-link></th>
            <th class="right"><sort-link name="total">{{ $t('profit.header.total') }}</sort-link></th>
            <th class="right"><sort-link name="profitTop">{{ $t('profit.header.profit') }}</sort-link></th>
          </tr>
          </thead>
          <template #body="sort">
            <tbody v-if="sells">
              <tr
                v-for="(sell, i) in sort.values"
                :key="i"
                :class="{
                    hidden: sell.side !== 3 && currentSymbol !== sell.symbol,
                    sub: sell.side === 2,
                  }"
              >
                <td>
                  {{ sell.symbol | symbol }}
                </td>
                <td>
                  {{ sell.created_at | formatDate('dateTime') }}
                </td>
                <td class="right">
                  {{ sell.avgBuyPrice | currency('', '₮') }}
                </td>
                <td class="right">
                  {{
                    sell.soldPrice | currency('', '₮')
                  }}
                </td>
                <td class="right">
                  {{
                    sell.amount | currency('no-precision', '')
                  }}
                </td>
                <td class="right">
                  {{
                    sell.total | currency('', '₮')
                  }}
                </td>
                <td class="right">
                  <p>
                    {{
                      sell.profitTop | currency('', '₮')
                    }}
                  </p>
                  <p class="percent">
                    {{
                      sell.profitBottom | currency('no-precision', '%')
                    }}%
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </sorted-table>
<!--        <table class="ic-table" id="profit_table">-->
<!--          <thead>-->
<!--            <tr>-->
<!--              <th>{{ $t('profit.header.symbol') }}</th>-->
<!--              <th>{{ $t('profit.header.date') }}</th>-->
<!--              <th class="right">{{ $t('profit.header.buy_price') }}</th>-->
<!--              <th class="right">{{ $t('profit.header.sell_price') }}</th>-->
<!--              <th class="right">{{ $t('profit.header.quantity') }}</th>-->
<!--              <th class="right">{{ $t('profit.header.total') }}</th>-->
<!--              <th class="right">{{ $t('profit.header.profit') }}</th>-->
<!--            </tr>-->
<!--          </thead>-->
<!--          <tbody v-if="sells">-->
<!--            <tr-->
<!--              v-for="(sell, i) in sells"-->
<!--              :key="`sell${i}`"-->
<!--              :class="{-->
<!--                hidden: sell.side !== 3 && currentSymbol !== sell.symbol,-->
<!--                sub: sell.side === 2,-->
<!--              }"-->
<!--            >-->
<!--              <td>-->
<!--                <input-->
<!--                  class="mr-2"-->
<!--                  type="checkbox"-->
<!--                  v-if="sell.side === 3"-->
<!--                  :checked="currentSymbol === sell.symbol && sell.side === 3"-->
<!--                  @click="appendItem(sell.symbol, sell)"-->
<!--                />-->
<!--                {{ sell.symbol | symbol }}-->
<!--              </td>-->
<!--              <td>-->
<!--                {{ sell.created_at | formatDate('dateTime') }}-->
<!--              </td>-->
<!--              <td class="right">-->
<!--                {{ sell.avgBuyPrice | currency('', '₮') }}-->
<!--              </td>-->
<!--              <td class="right">-->
<!--                {{-->
<!--                  sell.side === 2-->
<!--                    ? sell.unit_price-->
<!--                    : sell.avgBuyPrice | currency('', '₮')-->
<!--                }}-->
<!--              </td>-->
<!--              <td class="right">-->
<!--                {{-->
<!--                  sell.side === 2-->
<!--                    ? sell.quantity-->
<!--                    : totalQuantity(sell) | currency('no-precision', '')-->
<!--                }}-->
<!--              </td>-->
<!--              <td class="right">-->
<!--                {{-->
<!--                  sell.side === 2-->
<!--                    ? sell.order_amount-->
<!--                    : totalAmount(sell) | currency('', '₮')-->
<!--                }}-->
<!--              </td>-->
<!--              <td class="right">-->
<!--                <p>-->
<!--                  {{-->
<!--                    sell.side === 2-->
<!--                      ? sell.order_amount - sell.quantity * sell.avgBuyPrice-->
<!--                      : (totalAmount(sell) - -->
<!--                          totalQuantity(sell) * sell.avgBuyPrice)-->
<!--                        | currency('', '₮')-->
<!--                  }}-->
<!--                </p>-->
<!--                <p class="percent">-->
<!--                  {{-->
<!--                    sell.side === 2-->
<!--                      ? ((sell.order_amount - -->
<!--                          sell.quantity * sell.avgBuyPrice) /-->
<!--                          sell.order_amount) *-->
<!--                        100-->
<!--                      : (((totalAmount(sell) - -->
<!--                          totalQuantity(sell) * sell.avgBuyPrice) /-->
<!--                          totalAmount(sell)) *-->
<!--                          100)-->
<!--                        | currency('no-precision', '%')-->
<!--                  }}%-->
<!--                </p>-->
<!--              </td>-->
<!--            </tr>-->
<!--          </tbody>-->
<!--        </table>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'

export default {
  components: {},
  data() {
    return {
      currentSymbol: '',
      values: [],
    }
  },
  computed: {
    ...mapGetters([
      'remoteBalance',
      'shareBalance',
      'calculatedShareBalance',
      'calculatedShareBalanceAll',
      'totalShareBalance',
      'tradeHistory',
      'remoteBalanceLoading',
      'shareBalanceLoading',
    ]),
    sells() {
      if (this.calculatedShareBalanceAll) {
        return this.calculatedShareBalanceAll.filter(
          (item) => (item.side === 2 || item.side === 3) && item.order_amount
        )
      } else {
        return null
      }
    },
  },
  async created() {
    if (this.shareBalance === null || this.tradeHistory === null) {
      await this.fetchData()
    }
    this.populateTable()
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('fetchTradeHistory')
      await Promise.all([
        this.$store.dispatch('fetchRemoteBalance'),
        this.$store.dispatch('fetchShareBalance'),
      ])
    },
    populateTable() {
      console.debug(this.sells)
      this.values = this.sells
      this.values = this.sells.map((item) => {
        return {
          symbol: item.symbol,
          created_at: item.created_at,
          side: item.side,
          avgBuyPrice: item.avgBuyPrice,
          unit_price: item.unit_price,
          quantity: item.quantity,
          order_amount: item.order_amount,
          soldPrice: item.side === 2
            ? (item.order_amount / item.quantity) || item.unit_price
            : (this.totalAmount(item) / this.totalQuantity(item)) || item.avgBuyPrice,
          amount: item.side === 2
            ? item.quantity
            : this.totalQuantity(item),
          total: item.side === 2
            ? item.order_amount
            : this.totalAmount(item),
          profitTop: item.side === 2
            ? item.order_amount - item.quantity * item.avgBuyPrice
            : (this.totalAmount(item) -
              this.totalQuantity(item) * item.avgBuyPrice),
          profitBottom: item.side === 2
            ? ((item.order_amount -
                item.quantity * item.avgBuyPrice) /
              item.order_amount) *
            100
            : (((this.totalAmount(item) -
                  this.totalQuantity(item) * item.avgBuyPrice) /
                this.totalAmount(item)) *
              100),
        }
      })
    },
    appendItem(symbol, item) {
      if (item.side === 3) {
        if (this.currentSymbol !== symbol) this.currentSymbol = symbol
        else this.currentSymbol = null
      }
    },
    totalQuantity(sell) {
      let q = 0
      this.sells.forEach((e) => {
        if (e.symbol === sell.symbol && e.side === 2) {
          q += parseInt(e.quantity)
        }
      })
      return q
    },
    totalAmount(sell) {
      let a = 0
      this.sells.forEach((e) => {
        if (e.symbol === sell.symbol && e.side === 2) {
          a += parseFloat(e.order_amount)
        }
      })
      return a
    },
  }
}
</script>

<style lang="scss">
@import './ProfitPage.scss';
</style>
